import { AnyAction } from 'redux';

import OrganizationActionType from './ActionTypes';
import { OrganizationState } from './CompanyInformationTypes';

const initialState: OrganizationState = {
  id: '',
  name: '',
  legalAddress: '',
  organizationLogo: null,
  regionSettings: {
    currencyFormat: '',
    dateFormat: '',
    phoneNumberFormat: '',
  },
  primaryContact: '',
  country: '',
  apiCredentials: {
    clientId: '',
    clientSecret1: '',
    clientSecret2: '',
    publicKey: '',
  },
  isLoading: false,
  purchasedSeats: null,
  occupiedSeats: null,
  isSeatsLoading: false,
  isSeatsAreFullPopUpOpen: false,
  createdAt: new Date(),
};

const CompanyInformationReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case OrganizationActionType.GetOrganizationInfoSuccess: {
      const {
        id,
        legalAddress,
        country,
        name,
        products,
        primaryContact,
        imageId,
        regionSettings,
        apiCredentials,
        createdAt,
      } = action.payload;

      return {
        ...state,
        error: '',
        isLoading: false,
        id,
        legalAddress,
        country,
        primaryContact,
        organizationLogo: imageId,
        name,
        regionSettings,
        products,
        apiCredentials,
        createdAt: new Date(createdAt),
      };
    }
    case OrganizationActionType.GetOrganizationInfoFailure: {
      const { message } = action.payload;
      return {
        ...state,
        error: message,
        isLoading: false,
      };
    }
    case OrganizationActionType.GetOrganizationInfo: {
      return {
        ...state,
        error: '',
        isLoading: true,
      };
    }
    case OrganizationActionType.ChangeOrganizationInfoSuccess: {
      const { address } = action.payload.org;
      return {
        ...state,
        error: '',
        legalAddress: address.legalAddress,
        isLoading: false,
      };
    }
    case OrganizationActionType.ChangeOrganizationInfoFailure: {
      const { message } = action.payload;
      return {
        ...state,
        error: message,
        isLoading: false,
      };
    }
    case OrganizationActionType.ChangeOrganizationInfoRequest: {
      const { legalAddress, country, primaryContact } = action.payload;

      return {
        ...state,
        legalAddress,
        country,
        primaryContact,
        error: '',
        isLoading: true,
      };
    }
    case OrganizationActionType.GetSeats: {
      return {
        ...state,
        isSeatsLoading: true,
      };
    }
    case OrganizationActionType.GetSeatsSuccess: {
      const { purchasedSeats, occupiedSeats } = action.payload;

      return {
        ...state,
        purchasedSeats,
        occupiedSeats,
        isSeatsLoading: false,
      };
    }
    case OrganizationActionType.OpenSeatsAreFullPopUp: {
      return {
        ...state,
        isSeatsAreFullPopUpOpen: true,
      };
    }
    case OrganizationActionType.CloseSeatsAreFullPopUp: {
      return {
        ...state,
        isSeatsAreFullPopUpOpen: false,
      };
    }
    default:
      return state;
  }
};

export default CompanyInformationReducer;
